<div *ngIf="configSvc.currentConfigValue.userEntity" class="d-flex justify-content-between mb-4">
  <div class="d-flex align-items-center " id="entries">
    <span>{{ 'DATATABLE.SHOW' | translate }}</span>
    <select class="form-select" style="width: unset" [(ngModel)]="pagination.perPage" (change)="onPageChanged()">
      <option>2</option>
      <option>5</option>
      <option>10</option>
      <option>20</option>
      <option>30</option>
    </select>
    <span>{{ 'DATATABLE.PERPAGE' | translate }}</span>
  </div>
</div>
<div class="table-responsive">
    <table class="table table-hover">
        <thead>
            <tr>
                <th scope="col" *ngFor="let column of columns"
                    [class.sortable-col]="sortableColumns.includes(column)"
                    (click)="sortableColumns.includes(column) ? sortBy(column) : null">
                    <span>{{ 'DATATABLE.COLUMN.' + column.toUpperCase() | columnTranslate : column + ' ** ' }}</span>
                    <ng-container *ngIf="sortableColumns.includes(column)">
                        <i class="bi bi-caret-up-fill" *ngIf="currentSort === column && currentOrder === 'asc'"></i>
                        <i class="bi bi-caret-down-fill" *ngIf="currentSort === column && currentOrder === 'desc'"></i>
                        <i class="bi bi-caret-up" *ngIf="currentSort !== column"></i>
                    </ng-container>
                </th>
            </tr>
        </thead>
        <ng-content></ng-content>
    </table>
</div>
<nav class="d-flex justify-content-between py-2" *ngIf="items">
  <caption>
    <span>{{ 'DATATABLE.SHOWINGTOTAL' | translate:{ x: items.from, y: items.to, z: items.total } }}</span>
  </caption>
  <ng-container
    *ngFor="let item of items.data | paginate: { itemsPerPage: pagination.perPage, currentPage: pagination.page, totalItems: items.total }"></ng-container>
  <pagination-controls (pageChange)="onPageChanged($event)" [previousLabel]="'DATATABLE.PREVIOUS' | translate"
    [nextLabel]="'DATATABLE.NEXT' | translate"></pagination-controls>
</nav>





